import { useContext, useEffect, useState } from "react";
import { AppContext } from "../Context/Context";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

//used to get active feature for minimization & follow modal
// as indoor and new time machine share the same flow and structure.

const useMinimizedModalFeature = () => {
  const [feature, setFeature] = useState("indoorMap");
  const { pathname } = useLocation();

  const { timeMachineV2ModeIsEnabled } = useSelector(
    (state) => state.newTimeMachine
  );

  useEffect(() => {
    if (timeMachineV2ModeIsEnabled && pathname.includes("new-time-machine"))
      setFeature("newTimeMachine");
    else setFeature("indoorMap");
  }, [pathname, timeMachineV2ModeIsEnabled]);

  return { feature };
};

export default useMinimizedModalFeature;
